export enum SliceType {
  DigestHighlightsSlice = 'digest_highlights_slice',
  EmailFormSlice = 'email_form_slice',
  MetadataSlice = 'metadata_slice',
  HeroSlice = 'hero_slice',
}

export interface Slice<D, T extends SliceType, I = undefined> {
  id: string;
  name: string;
  docURL: string;
  version: string;
  description: string;
  primary: D;
  items: I;
  slice_type: T;
}
